import { createContext } from 'react';
import { IStaticContentFiltersFormValues } from '../../ModalView/StaticContentFiltersModal/StaticContentFiltersForm/StaticContentFiltersForm';

export const StaticContentContext = createContext({
  filters: {} as IStaticContentFiltersFormValues,
  updateFilters: (filters: IStaticContentFiltersFormValues) => {},
});
